import { NgModule, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { FileUploadModule } from '../module/custom-fileupload/fileupload.module';
import { CustomEmailTextboxModule } from '../module/custom-email-textbox/email-textbox.module';
import { CustomWarningDialogModule } from '../module/custom-warning-popup/custom-warning-dialog.module';
import { CustomAlertStripModule } from '../module/custom-alert-strip/alert-strip.module';
import { CustomPaginatorModule } from '../module/custom-paginator/paginator.module';

import { AllergyDialogComponent } from '@pages/patientfacesheet/dialog/allergy-dialog/allergy-dialog.component';
import { ProblemsDialogComponent } from '@pages/patientfacesheet/dialog/problems-dialog/problems-dialog.component';
import { BasicFormComponent } from '@pages/patient/createedit/basic-form.component';
import { NgxMaskModule } from 'ngx-mask';
import { CustomEditorModule } from '../module/custom-editor/custom-editor.module';
import { CustomEditorDialogModule } from '../module/custom-editor-dialog/custom-editor-dialog.module';
import { AuthorizationFormComponent } from '@pages/patient/authorization/authorization-form.component';
import { InsuranceFormComponent } from '@pages/patient/insurance/insurance-form.component';
import { ReplacePipe } from '@helpers/replace-pipe';
import { CustomInputTextboxModule } from '../module/custom-input-text/input-text.module';
import { CustomInputTextareaModule } from '../module/custom-input-textarea/input-textarea.module';
import { CustomAutoCompleteModule } from '../module/custom-mat-autocomplete/custom-autocomplete.module';
import { PatientNoteDialogComponent } from '@pages/clinicalnotes/dialog/patientnote/patientnote.component';
import { AmountValidationDialogModule } from '@pages/payment/dialog/amountvalidation/amountvalidation.module';
import { AdjustTransactionModule } from '@pages/payment/transaction/adjust-transaction.module';
import { TransactionTabModule } from '@pages/claimdashboard/tabs/transaction-tab/createedit/transaction-tab.module';
import { AppointmentDialogModule } from '../pages/calendar/dialog/appointment-dialog/appointment-dialog.module';
import { MedicationDialogComponent } from '@pages/patientfacesheet/dialog/medication-dialog/medication-dialog.component';
import { CustomDataTableModule } from '@module/custom-data-table/custom-data-table.module';
import { ClaimPaymentDialogComponent } from '@pages/patientfacesheet/dialog/claimpayment-dialog/claimpayment.component';

@NgModule({
  declarations: [
    AllergyDialogComponent,
    MedicationDialogComponent,
    ProblemsDialogComponent,
    BasicFormComponent,
    AuthorizationFormComponent,
    InsuranceFormComponent,
    ReplacePipe,
    PatientNoteDialogComponent,
    ClaimPaymentDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSortModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    FileUploadModule,
    CustomEmailTextboxModule,
    MatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    CustomEditorModule,
    CustomEditorDialogModule,
    CustomWarningDialogModule,
    CustomAlertStripModule,
    CustomInputTextboxModule,
    CustomInputTextareaModule,
    CustomAutoCompleteModule,
    NgxMaskModule.forRoot(),
    AmountValidationDialogModule,
    AdjustTransactionModule,
    TransactionTabModule,
    AppointmentDialogModule,
    CustomPaginatorModule,
    CustomDataTableModule
  ],
  exports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSortModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    FileUploadModule,
    CustomEmailTextboxModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule,
    CustomEditorModule,
    CustomEditorDialogModule,
    CustomWarningDialogModule,
    CustomAlertStripModule,
    AmountValidationDialogModule,
    AdjustTransactionModule,
    TransactionTabModule,
    AppointmentDialogModule,
    CustomPaginatorModule,
    CustomDataTableModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class SharedModule {}
